module.exports = {
  "menu.btn.profile": "Perfil",
  "menu.btn.shop": "Tienda",
  "menu.btn.social": "Social",
  "menu.btn.maps": "Mapas",
  "menu.btn.mods": "Mods",
  "menu.btn.settings": "Configuraciones",
  "menu.btn.customize": "Personalizar",
  "menu.btn.invite": "Invitar",
  "menu.btn.invite.clicked": "Copiado",
  "menu.btn.join": "Unirse",
  "menu.btn.host": "Ser Anfitrin de Partida",
  "menu.btn.browser": "Buscador de Servidores",
  "generic.wait": "Favor esperar...",
  "generic.loading": "CARGANDO...",
  "generic.connecting": "CONECTANDO...",
  "generic.none": "Ninguno",
  "generic.select": "Seleccionar",
  "generic.delete": "Eliminar",
  "generic.save": "Guardar",
  "generic.load": "Cargar",
  "generic.search": "Buscar",
  "generic.leave": "Salir",
  "generic.default": "Por Defecto",
  "generic.submit": "Entregar",
  "generic.create": "Crear",
  "generic.failed": "Fallido",
  "generic.success": "��xito!",
  "generic.name": "Nombre",
  "generic.level": "Nivel",
  "generic.score": "Puntuaci�n",
  "generic.off": "Off",
  "generic.score": "Puntuaci�n",
  "generic.victory": "VICTORIA",
  "generic.defeat": "DERROTA",
  "generic.follow": "Seguir",
  "generic.unfollow": "Dejar de Seguir",
  "generic.followers": "Seguidores",
  "generic.following": "Siguiendo",
  "generic.games": "Juegos",
  "generic.wins": "Victorias",
  "generic.clan": "Clan",
  "generic.kills": "Asesinatos",
  "generic.deaths": "Muertes",
  "generic.kdr": "TAM",
  "generic.games.played": "Partidas Jugadas",
  "generic.games.won": "Partidas Ganadas",
  "generic.timep": "Tiempo de Juego",
  "generic.time": "Tiempo",
  "generic.logout": "Cerrar Sesi�n",
  "generic.logout.sessions": "Cerrar Todas las Sesiones",
  "generic.username": "Ingresar Usuario",
  "generic.password": "Ingresar Contrase�a",
  "generic.register": "Registrarse",
  "generic.login": "Iniciar Sesi�n",
  "generic.accuracy": "Precisi�n",
  "player.waiting": "esperando jugadores",
  "player.died": "Has muerto",
  "player.killed": "Asesinado Por",
  "player.killstreak": "{0} tiene Racha de {1} Asesinatos",
  "player.inactive": "Desconectado por inactividad",
  "player.disconnect": "DESCONECTADO",
  "timer.end": "Pr�xima Ronda en {0}",
  "leaderboard.empty": "Lobby Vac�o",
  "popup.checkpoint": "�Checkpoint!",
  "app.play": "CLICK PARA JUGAR",
  "app.play.controller": "PRESIONA START",
  "purchase.error": "Ocurri� un error",
  "purchase.error.click": "�click aqu�</a> e int�ntalo de nuevo!",
  "purchase.error.limit": "Es posible que hayas excedido tu l�mite diario de transacciones",
  "settings.reset": "Restablecer Configuraciones",
  "settings.reset.confirm": "�Est�s seguro de querer restablecer todas tus configuraciones? Esto tambi�n volver� a cargar la p�gina",
  "settings.controls.change": "Cambiar Controles",
  "settings.controls.press": "Presiona cualquier Tecla",
  "settings.server.header": "Servidores",
  "settings.server.region": "Regi�n por defecto",
  "settings.quality.header": "Calidad",
  "settings.quality.res": "Resoluci�n",
  "settings.quality.part": "Part�culas",
  "settings.quality.trails": "Rastros de Bala",
  "settings.quality.mflash": "Combusti�n",
  "settings.interface.header": "Interfaz",
  "settings.interface.ui": "Mostrar Interfaz",
  "settings.interface.hp": "Barras Din�micas de HP",
  "settings.interface.chat": "Mostrar Caja de Chat",
  "settings.interface.kills": "Mostrar Historial de Asesinatos",
  "settings.interface.messages": "Mostrar Aperturas de Cajas",
  "settings.interface.ping": "Mostrar PING",
  "settings.interface.fps": "Mostrar FPS",
  "settings.interface.deaths": "Mostrar Muertes",
  "settings.crosshair.header": "Ret�culo",
  "settings.crosshair.type": "Tipo",
  "settings.crosshair.type.2": "Personalizado",
  "settings.crosshair.type.3": "Por Capas",
  "settings.crosshair.type.4": "Imagen",
  "settings.crosshair.style": "Estilo",
  "settings.crosshair.style.0": "Cruz",
  "settings.crosshair.style.1": "C�rculo Vac�o",
  "settings.crosshair.style.2": "C�rculo Macizo",
  "settings.crosshair.style.3": "Cuadrado Vac�o",
  "settings.crosshair.style.4": "Cuadrado Macizo",
  "settings.crosshair.image": "Imagen",
  "settings.crosshair.image.paste": "Imagen del Ret�culo",
  "settings.crosshair.always": "Mostrar Siempre",
  "settings.crosshair.color": "Color",
  "settings.crosshair.shadow": "Sombra",
  "settings.crosshair.size": "Tama�o",
  "settings.crosshair.thickness": "Grosor",
  "settings.onKillS.style.0": "Por Defecto",
  "settings.onKillS.style.1": "Reducir Resoluci�n",
  "settings.onKillS.style.2": "Reducir Campo Visual",
  "settings.onKillS.style.3": "Aumentar Campo Visual",
  "settings.gameplay.header": "Jugabilidad",
  "settings.gameplay.sensitivity": "Sensibilidad",
  "settings.gameplay.aimsens": "Sensibilidad al Apuntar",
  "settings.gameplay.fov": "Campo Visual",
  "settings.gameplay.fps": "Campo Visual de Arma",
  "settings.gameplay.streamer": "Modo Streamer",
  "settings.gameplay.challenge": "Modo Challenge",
  "settings.gameplay.invert": "Invertir Eje Y",
  "settings.gameplay.onkillS": "Al Asesinar",
  "settings.audio.header": "Audio",
  "settings.audio.sound": "Sonido",
  "settings.audio.voice": "Volumen de Voces",
  "settings.editing.header": "Edici�n",
  "settings.editing.weapon": "Mostrar Arma",
  "settings.editing.bobbing": "Descuadre de Apunte",
  "settings.editing.depth": "Mapa de Profundidad",
  "settings.editing.green": "Pantalla Verde",
  "settings.shaders.header": "Sombreadores",
  "settings.shaders.ambient": "Sombreo de Ambiente",
  "settings.mods.header": "Mods",
  "settings.mods.load": "Cargar Mods",
  "settings.mods.auto": "Auto-Cargar Mod",
  "settings.mods.borders": "Bordes de la Mirilla",
  "settings.mods.scope": "Imagen de Mirilla",
  "settings.mods.scope.paste": "URL Imagen de la Mirila",
  "settings.mods.dot": "Imagen del Punto Rojo",
  "settings.mods.dot.paste": "URL Imagen del Punto Rojo",
  "settings.mods.endmessage": "Mensaje Fin de Partida",
  "settings.mods.profile": "Imagen del Perfil",
  "settings.mods.profile.paste": "URL Imagen del Perfil",
  "windows.settings.header": "Configuraciones del Juego",
  "windows.servers.header": "Buscador de Servidores",
  "windows.servers.none": "No Hay Partidas para Unirse...",
  "windows.servers.host": "+ Ser Anfitri�n de Partida",
  "windows.servers.hide": "Hide Full",
  "windows.servers.online": "{0} totales en l�nea",
  "windows.loadout.header": "Cambiar Loadout",
  "windows.loadout.class": "Clase",
  "windows.loadout.primary": "Primaria",
  "windows.loadout.secondary": "Secundaria",
  "windows.loadout.melee": "Melee",
  "windows.loadout.hat": "Cabeza",
  "windows.loadout.body": "Cuerpo",
  "windows.loadout.spray": "Spray",
  "windows.mods.header": "Gestor de Mods",
  "windows.mods.guide": "Gu�a de Mods",
  "windows.mods.list": "Lista de Mods",
  "windows.mods.publish": "Publicar Mod",
  "windows.mods.viewer": "Vista",
  "windows.mods.drop": "arrastar archivo de mod aqu� o click",
  "windows.mods.paste": "Pegar Url de Mod",
  "windows.mods.load": "Cargar Mod",
  "windows.account.header": "Cuenta",
  "windows.account.recover": "Para recuperar una cuenta, contactar a <a>krunker@yendis.ch</a>",
  "windows.class.header": "Seleccionar Clase",
  "windows.controls.header": "Cambiar Controles",
  "windows.controls.forward": "Adelante",
  "windows.controls.backward": "Atr�s",
  "windows.controls.left": "Izquierda",
  "windows.controls.right": "Derecha",
  "windows.controls.reload": "Recargar",
  "windows.controls.aim": "Apuntar",
  "windows.controls.inspect": "Inspeccionar",
  "windows.controls.spray": "Spray",
  "windows.controls.jump": "Saltar",
  "windows.controls.crouch": "Agacharse",
  "windows.controls.next": "Arma Siguiente",
  "windows.controls.previous": "Arma Anterior",
  "windows.controls.chat": "Chat",
  "windows.controls.voice": "Voz",
  "windows.controls.list": "Lista de Jugadores",
  "windows.controls.interact": "Interactuar",
  "windows.controls.drop": "Soltar",
  "windows.host.header": "Ser Anfitri�n de Partida Personalizada",
  "windows.host.maps": "Seleccionar Mapas",
  "windows.host.cmaps": "Mapa Comunitario",
  "windows.host.raw": "Datos no procesados de Mapa",
  "windows.host.modes": "Seleccionar Modos",
  "windows.host.classes": "Seleccionar Clases",
  "windows.host.settings": "Configuraci�n del Servidor",
  "windows.host.preset": "Configuraciones Previas del Anfitri�n",
  "windows.host.preset.load": "Cargando Configuraciones Previas...",
  "windows.host.preset.name": "Nombre de las Configuraciones Previas",
  "windows.host.start": "Iniciar Partida",
  "windows.spray.header": "Seleccionar Spray",
  "windows.spray.default": "Spray por Defecto",
  "windows.maps.header": "Mapas Personalizados",
  "windows.maps.none": "�No se encontraron mapas!",
  "windows.maps.name": "Nombre del Mapa",
  "windows.maps.editor": "Editor de Mapas",
  "windows.maps.publish": "Publicar Mapa",
  "windows.maps.community": "Comunidad de Mapas",
  "windows.publish.map.header": "Publicar Mapa",
  "windows.publish.map.thumbnail": "Sin Miniatura",
  "windows.publish.map.paste": "Pegar Datos de Mapa",
  "windows.publish.map.update": "Publicar/Actualizar",
  "windows.publish.map.login": "�Inicia sesi�n</a> para crear y subir mapas!",
  "windows.theatre.header": "Modo Teatro",
  "windows.theatre.record": "Permitir Grabar",
  "windows.theatre.key": "Tecla de Grabar",
  "windows.clans.header": "Clanes",
  "windows.clans.members": "Miembros ({0})",
  "windows.clans.requests": "Solicitudes",
  "windows.clans.requests.none": "No Hay Solicitudes",
  "windows.clans.page": "[{0}] P�gina del Clan",
  "windows.clans.create": "Crear Clan",
  "windows.clans.name": "Nombre del Clan",
  "windows.clans.view": "Ver Clanes",
  "windows.clans.join": "Unirse a Clan",
  "windows.clans.login": "�Inicia sesi�n</a> para crear un clan o unirte a uno!",
  "windows.store.header": "Tienda",
  "windows.store.spin": "{0} Girar",
  "windows.store.agree": "Al comprar, aceptas los {0}T�rminos",
  "windows.store.purchase": "Comprar KR",
  "windows.store.market": "Mercado",
  "windows.store.market2": "Krunker Market",
  "windows.store.buy": "Compra y Vende items en el ",
  "windows.store.wheels": "Ruedas de Premios",
  "windows.store.unlock": "Desbloquea nuevos aspectos para armas e items",
  "windows.store.amount": "{0} KR en la cuenta",
  "windows.store.login": "�Inicia sesi�n</a> para comprar y desbloquear items de la tienda!",
  "windows.store.purchasing": "Comprando...",
  "windows.store.unboxed": "{0}{1} abri�",
  "windows.skin.header": "Seleccionar Aspecto",
  "windows.hat.header": "Seleccionar Cabeza",
  "windows.back.header": "Seleccionar Espalda",
  "windows.mods.community.header": "Mods Comunitarios",
  "windows.mods.community.fav": "Tus Favoritos",
  "windows.mods.community.new": "Mods Nuevos",
  "windows.mods.community.hot": "Hot",
  "windows.mods.community.name": "Nombre del Mod",
  "windows.mods.community.none": "�No se encontraron Mods!",
  "windows.publish.mod.header": "Publicar Mod",
  "windows.publish.mod.thumbnail": "Sin Miniatura",
  "windows.publish.mod.name": "Nombre del Mod",
  "windows.publish.mod.paste": "Url del Mod",
  "windows.publish.mod.update": "Publicar/Actualizar",
  "windows.publish.mod.login": "�Inicia sesi�n</a> para crear y subir mods!",
  "windows.secondary.header": "Seleccionar Secundario",
  "windows.secondary.unlocked": "Desbloqueado en el Nvl {0}",
  "windows.secondary.req": "Nvl Req {0}",
  "windows.advertise.header": "Anunciar",
  "windows.players.header": "Lista de Jugadores",
  "windows.players.none": "No hay jugadores actualmente...",
  "windows.join.header": "Unirse",
  "windows.join.code": "Ingresar URL/C�digo de Partida",
  "windows.client.header": "Cliente",
  "windows.client.windows": "Instalador Windows",
  "windows.client.mac": "Instalador macOS",
  "windows.client.linux": "Instalador Linux",
  "thumbnail.upload.limit": "Error. L�mite Miniatura de 40kb",
  "thumbnail.upload.error": "Error de Miniatura",
  "mod.extracting": "extrayendo {0}/{1}",
  "mod.disabled": "mods desactivados",
  "mod.error": "�error de mod!",
  "mod.loading": "cargando mod...",
  "mod.invalid": "�archivo de mod inv�lido!",
  "matchmaker.full": "FULL",
  "matchmaker.full2": "La partida est� full.",
  "matchmaker.none": "No se encontr� partida.",
  adblocker: "Desactiva tu ad blocker para recibir Krunkies gratis.",
  "streamers.views": "{0} vespectadores",
  "streamers.none": "�No hay streams activos!",
  "error.extentions": "Si tienes extensiones. Desact�valas",
  "error.seek": "Intenta buscar un nuevo juego haciendo click",
  "custom.map.missing": "Selecciona al menos un Mapa",
  "custom.mode.missing": "Selecciona al menos un Modo",
  "custom.class.missing": "Selecciona al menos una Clase",
  "server.config.maxPlayers": "Jugadores",
  "server.config.minPlayers": "M�nimo de Jugadores",
  "server.config.lives": "Vidas",
  "server.config.gameTime": "Minutos",
  "server.config.gravMlt": "Gravedad",
  "server.config.jumpMlt": "Intensidad de Saltos",
  "server.config.deltaMlt": "Escala de Tiempo",
  "server.config.strafeSpd": "Velocidad de R�faga",
  "server.config.healthMlt": "Multiplicador de la Vida",
  "server.config.impulseMlt": "Impulso de Arma",
  "server.config.nameTeam1": "Nombre Equipo 1",
  "server.config.nameTeam2": "Nombre Equipo 2",
  "server.config.selTeam": "Seleccionar Equipo",
  "server.config.allowSpect": "Espectar",
  "server.config.killRewards": "Recompensa por Asesinatos",
  "server.config.canSlide": "Deslizar",
  "server.config.autoJump": "Auto Saltar",
  "server.config.thirdPerson": "3ra Persona",
  "server.config.nameTags": "Esconder Se�al del Nombre",
  "server.config.private": "Privado",
  "social.login": "Iniciar sesi�n/Registrarse",
  "social.login.failed": "Inicio de sesi�n fallido",
  "social.login.buy": "Inicia sesi�n para Comprar",
  "social.login.sell": "Inicia sesi�n para Vender",
  "social.login.proccessing": "Iniciando sesi�n...",
  "social.since": "Desde",
  "social.user.maps": "Mapas de Usuarios",
  "social.user.mods": "Mods de Usuarios",
  "social.maps.none": "No se encontraron Mapas...",
  "social.market.head": "Item de Cabeza",
  "social.market.back": "Item de Espalda",
  "social.market.none": "No se encontraron Items",
  "social.market.grace": "listo en {0}",
  "social.market.sort": "Filtrar/Organizar",
  "social.market.filter": "Busca",
  "social.market.price.high": "Precio m�s alto",
  "social.market.price.low": "Precio m�s bajo",
  "social.market.price.list": "Listar Precio en",
  "social.market.searching": "Buscando",
  "social.market.listed": "incluido hace {0}",
  "social.market.list": "Item de Lista",
  "social.market.unlist": "Excluir",
  "social.market.unlisting": "Excluyendo Item...",
  "social.market.posting": "Publicando Item...",
  "social.market.req": "Nvl {0} requerido",
  "social.market.cant": "Saldo Insuficiente",
  "social.market.purchase": "Comprar",
  "social.market.fee": "Sin Costo de Incluir",
  "social.market.failed": "Fallido. Intenta de nuevo"
};